<template>

</template>

<script>
const httpUrl = "https://m.jlwater.com"
const showUrl = "https://m.jlwater.com"
export default {
  httpUrl,
  showUrl
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Common.vue